module.exports = __webpack_public_path__ + "media/images/nist_logo_brand_white-7299d810b724dc525113a077a5354a2e.svg";